import { render } from "./AppDevelopmentPage.vue?vue&type=template&id=89cde49e"
import script from "./AppDevelopmentPage.vue?vue&type=script&lang=js"
export * from "./AppDevelopmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__